import { render } from "./ModalDetailsValueRenderer.vue?vue&type=template&id=2d365c1e&scoped=true"
import script from "./ModalDetailsValueRenderer.vue?vue&type=script&lang=js"
export * from "./ModalDetailsValueRenderer.vue?vue&type=script&lang=js"

import "./ModalDetailsValueRenderer.vue?vue&type=style&index=0&id=2d365c1e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d365c1e"]])

export default __exports__